const glacierWaveDate: Record<string, { teaser: string; crowdfunding: string; detail: string }> = {
    jp: {
        teaser: '2023/04/19 16:00:00 GMT+8',
        crowdfunding: '2023/04/26 11:00:00 GMT+8',
        detail: '2023/05/17 23:00:00 GMT+8',
    },
    kr: {
        teaser: '2023/05/10 11:00:00 GMT+8',
        crowdfunding: '2023/05/26 11:00:00 GMT+8',
        detail: '2023/06/30 23:00:01 GMT+8',
    },
};

export const getGlacierWaveDateConfig = (locale: string) => glacierWaveDate[locale] || glacierWaveDate.jp;

export const getProductUrl = (locale: string) => {
    const obj: any = {
        jp: {
            glacierDetail: '/glacier-portable-refrigerator',
            wave2Detail: '/wave-2-portable-air-conditioner',
            glacierShopify: 'https://jp.ecoflow.com/products/glacier-portable-refrigerator',
            wave2Shopify: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner',
        },
        kr: {
            glacierDetail: '/glacier-portable-refrigerator',
            wave2Detail: '/wave-2-portable-air-conditioner',
        },
    };

    return obj[locale] || obj['jp'];
};
